


















































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
// import { Store } from "vuex";
import { readIncomes, readUserProfile } from "@/store/main/getters";
import {
  dispatchGetAgreedLicenceVersion,
  dispatchGetIncomes,
  dispatchGetUserProfile,
  dispatchSetLicenceAccepted
} from "@/store/main/actions";
import { readCurrencyName, readCurrencyPrice, readUserOneWallet } from "@/store/wallet/getters";
import moment from "jalali-moment";
import { dispatchGetCurrencies, dispatchGetPrices } from "@/store/wallet/actions";
import { dispatchGetLicence } from "@/store/main/actions";

@Component
export default class Dashboard extends Vue {
  public loading = true;
  public snackbar = false;
  public referralDialog = false;
  get greetedUser() {
    const userProfile = readUserProfile(this.$store);
    if (userProfile) {
      if (userProfile.full_name) {
        return userProfile.full_name;
      } else {
        return userProfile.email;
      }
    }
    return null;
  }
  get userProfile() {
    return readUserProfile(this.$store);
  }

  get lastTransactions(){
    const incomes = readIncomes(this.$store);
    if (incomes.length >= 3)
      return incomes.slice(0,3);
    if (incomes.length >= 2)
      return incomes.slice(0,2);
    if (incomes.length >= 1)
      return incomes.slice(0,1);
    else
      return null
  }

  public getCurrencyName(currencyId: number) {
    return readCurrencyName(this.$store)(currencyId);
  }



  public convertAmount(amount,currency){
    if (currency == "ETH")
      return (amount / 10 ** 18).toFixed(10)
    else if (currency == "ZIL")
      return (amount / 10 ** 12).toFixed(10)
    else if (currency == "XCC")
      return (amount / 10 ** 8).toFixed(10)
    else if (currency == "XCH")
      return (amount / 10 ** 12).toFixed(10)
    else
      return amount;
  }

  public toJalali(date){
    return moment(date, 'YYYY-M-DTHH:mm:ss.z')
      .locale('fa')
      .format('YYYY/M/D');
  }

  get eth_price() {
    return Math.round(readCurrencyPrice(this.$store)(2))?.toLocaleString();
  }

  get zil_price() {
    return Math.floor(readCurrencyPrice(this.$store)(14))?.toLocaleString();
  }

  get xch_price() {
    return Math.floor(readCurrencyPrice(this.$store)(15))?.toLocaleString();
  }

  get xcc_price() {
    return Math.floor(readCurrencyPrice(this.$store)(16))?.toLocaleString();
  }

  public copy2clipboard(text){
    navigator.clipboard.writeText(text);
    this.snackbar = true;
  }

  public async mounted() {
    this.loading = true;
    await dispatchGetUserProfile(this.$store);


    await Promise.allSettled([
      dispatchGetIncomes(this.$store),
      dispatchGetCurrencies(this.$store),
      dispatchGetPrices(this.$store),
      dispatchGetLicence(this.$store),
    ]);

    await this.checkLicence();


    this.loading = false;
  }

  public async checkLicence(){

    const licences = await dispatchGetLicence(this.$store);
    const currentVersion = licences.data.version;
    const agreed = await dispatchGetAgreedLicenceVersion(this.$store);
    const agreedLicenceVersion = agreed.data.version;

    console.log("agreed:"+agreedLicenceVersion+" currentVersion:"+currentVersion);

    if (currentVersion == agreedLicenceVersion)
      await dispatchSetLicenceAccepted(this.$store,true);
    else{
      await dispatchSetLicenceAccepted(this.$store,false);
      await this.$router.push({name:'main-licence'});
    }


  }


}
